interface DayBannerProps {
  dayNumber: number;
  date: Date | null;
  itemCount: number;
  subtotal: number;
  currencySymbol: string;
}

/**
 * Format a UTC Date object to display the correct date in any timezone.
 */
function formatUTCDate(date: Date): string {
  return new Intl.DateTimeFormat("en-US", {
    weekday: "long",
    month: "long",
    day: "2-digit",
    timeZone: "UTC",
  }).format(date);
}

export function DayBanner({
  dayNumber,
  date,
  itemCount,
  subtotal,
  currencySymbol,
}: DayBannerProps) {
  return (
    <div className="bg-secondary text-secondary-foreground px-4 py-3 rounded-t-lg flex items-center justify-between gap-3 mt-4">
      <div className="min-w-0">
        <div className="font-bold text-base sm:text-lg leading-tight">
          Day {dayNumber}
        </div>
        {date && (
          <div className="text-xs sm:text-sm text-secondary-foreground/70 truncate">
            {formatUTCDate(date)}
          </div>
        )}
      </div>
      <div className="text-right flex-shrink-0">
        <div className="text-xs text-secondary-foreground/70">
          {itemCount} {itemCount === 1 ? "item" : "items"}
        </div>
        {subtotal > 0 && (
          <div className="font-semibold text-sm sm:text-base">
            {currencySymbol}
            {subtotal.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </div>
        )}
      </div>
    </div>
  );
}
